import type { ReactNode } from 'react';
import { Icon } from '../../components/Icon';
import { ThemeToggle } from '../../components/ThemeToggle';

/** The centered card used by sign-in and the gate screens. */
export function AuthScreen({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="auth">
      <div style={{ position: 'fixed', top: 16, right: 16 }}>
        <ThemeToggle />
      </div>
      <main className="card" id="main">
        <div className="brand">
          <span className="logo">
            <Icon name="logo" />
          </span>
          SEO HQ
        </div>
        <h1>{title}</h1>
        {children}
      </main>
    </div>
  );
}
